import EditBookingDetails from 'modules/Admin/orders/EditBookingDetails'

function EditBookingPage() {
  return (
    <div className="w-full" data-testid="adminEditBookingPage">
      <EditBookingDetails />
    </div>
  )
}

export default EditBookingPage
